/**
 * @file LongProcess
 */
import Common from '../../Utils/Common';

/**
 * @classname LongProcess
 * @classdesc 長い処理時のローディング表示
 */
export default class LongProcess {
	/**
	 * @constructor
	 * @param {jQuery} $e - body
	 */
	constructor($e, controller) {
		console.log(`LongProcess.constructor`);
		this._$e = $e;
		const element = $e.prop('tagName').toLowerCase();
		if (element === 'button' && $e.attr('type') === 'button'){
			$e.on('click', (e) => {
				console.log('buttonタグクリック');
				Common.showLoading();
			})
		} else if (element === 'a') {
			const link = $e.attr('href');
			$e.on('click', (e) => {
				console.log('aタグクリック');
				e.preventDefault();
				Common.showLoading();
				if (link === '__LONG__') {
					setTimeout(() => {
						alert('hrefが"__LONG__"でない限り、きちんと遷移します。');
					}, 1500);
					setTimeout(() => {
						Common.hideLoading();
					}, 5000);
				} else {
					location.href = link;
				}
			})
		}
	}
}
